export var MESSAGE_TYPE = {
  OPEN: 'OPEN',
  MESSAGE: 'MESSAGE',
  CLOSE: 'CLOSE'
};
export var EVENT_TYPE = {
  AcceptStatusEvent: 'AcceptStatusEvent',
  ChatStateEvent: 'ChatStateEvent',
  ContentEvent: 'ContentEvent',
  SequenceMapEvent: 'SequenceMapEvent',
  CLOSE: 'CLOSE'
};
export var CHAT_STATUS_EVENT = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  GONE: 'GONE',
  COMPOSING: 'COMPOSING',
  PAUSE: 'PAUSE',
  READ: 'READ'
};
export var ACCEPT_STATUS_EVENT = {
  ACCEPT: 'ACCEPT',
  READ: 'READ'
};